export function ExtractThesaurusId(conceptUri: string) {
    // Example "https://webdev.mediahaven.com/thesaurus/conceptschemes/defensie/c/9" -> We extract the '9' part
    return conceptUri.split('/').pop();
}
